export default __webpack_public_path__ + "media/images/icons_fc/clock2-b8c2eccf318d381cc707cf7b1189fc40.png";